import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import DateTimeInput from 'components/DateTimeInput';
import sbatGroupResourceType from 'propTypes/sbatGroupResourceType';

export default function SbatGroupInput({ value, onChange, disabled = false }) {
  const [dateOfTopic, setDateOfTopic] = useState(value?.date_of_topic);

  useEffect(() => {
    setDateOfTopic(value?.date_of_topic || '');
  }, [value]);

  const handleDateOfTopicChange = useCallback(
    (newDateOfTopic) => {
      setDateOfTopic(newDateOfTopic);
      onChange({ ...value, date_of_topic: newDateOfTopic });
    },
    [onChange, value]
  );

  return (
    <DateTimeInput
      disabled={disabled}
      onChange={handleDateOfTopicChange}
      value={new Date(dateOfTopic).getTime()}
    />
  );
}

SbatGroupInput.propTypes = {
  value: sbatGroupResourceType,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
